import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import Seo from "./Components/Seo";
import Scroll from "./Components/Scroll";
import SingleProduct from "./Components/SingleProduct";
import WhatsAppButton from "./Components/WhatsAppButton";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import ServiceDetail from "./Pages/ServiceDetail";
import Services from "./Pages/Services";
import Privacy from "./Pages/Privacy";
import Certificates from "./Pages/certificates";
import { Gallery } from "./Pages/Gallery";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const legacyHashPath = window.location.hash;

    if (legacyHashPath.startsWith("#/")) {
      navigate(legacyHashPath.slice(1), { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <Seo />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/about" element={<About />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceSlug" element={<ServiceDetail />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/product/:id" element={<SingleProduct />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
      <Scroll />
    </>
  );
};

export default App;
